  /* Innovist main product: gallery, variants/packs, iCash popover, coupon copy, sticky bar spacer, Shiprocket EDD.
   Moved from sections/innovist-main-product.liquid (loaded deferred); per-product data stays inline as JSON. */
(function () {
  function init(root) {
    var sectionId = root.getAttribute('data-section-id');
    var sectionEl = root.closest('.shopify-section') || root.parentNode;
    var data = {};
    try {
      data = JSON.parse(root.querySelector('[data-inv-mp-json]').textContent);
    } catch (e) {}

    function money(cents, trimZeros) {
      var value = (Number(cents) || 0) / 100;
      var text = value.toLocaleString('en-US', {
        minimumFractionDigits: trimZeros && value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
      return '₹' + text;
    }

    /* ---------------- gallery ---------------- */
    var track = root.querySelector('[data-inv-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];

    function slideIndex() {
      if (!slides.length) return 0;
      var left = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var d = Math.abs(slide.offsetLeft - slides[0].offsetLeft - left);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }

    function goTo(i, instant) {
      if (!slides.length) return;
      var n = slides.length;
      i = ((i % n) + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }

    var hydrated = false;
    function hydrateSlides() {
      if (hydrated || !track) return;
      hydrated = true;
      track.querySelectorAll('img[data-srcset], img[data-src]').forEach(function (img) {
        var ss = img.getAttribute('data-srcset');
        var s = img.getAttribute('data-src');
        if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
        if (s) { img.setAttribute('src', s); img.removeAttribute('data-src'); }
      });
    }
    if (track) {
      ['pointerdown', 'touchstart', 'wheel', 'scroll', 'keydown'].forEach(function (type) {
        track.addEventListener(type, hydrateSlides, { passive: true, once: true });
      });
      var idleHydrate = function () {
        if (window.requestIdleCallback) requestIdleCallback(hydrateSlides, { timeout: 3000 });
        else setTimeout(hydrateSlides, 1500);
      };
      if (document.readyState === 'complete') idleHydrate();
      else window.addEventListener('load', idleHydrate, { once: true });
    }

    var prev = root.querySelector('[data-inv-prev]');
    var next = root.querySelector('[data-inv-next]');
    if (prev) prev.addEventListener('click', function () { hydrateSlides(); goTo(slideIndex() - 1); });
    if (next) next.addEventListener('click', function () { hydrateSlides(); goTo(slideIndex() + 1); });

    /* Innovist's Flickity gallery can be dragged with a mouse; native scroll-snap
       only swipes on touch, so add mouse dragging (a drag never opens the zoom). */
    var dragMoved = false;
    if (track) {
      var dragStartX = 0;
      var dragStartLeft = 0;
      var dragging = false;
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || slides.length < 2) return;
        dragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var dx = event.clientX - dragStartX;
        if (!dragMoved && Math.abs(dx) > 5) {
          dragMoved = true;
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          track.classList.add('is-dragging');
        }
        if (dragMoved) {
          event.preventDefault();
          track.scrollLeft = dragStartLeft - dx;
        }
      });
      window.addEventListener('pointerup', function (event) {
        if (!dragging) return;
        dragging = false;
        if (!dragMoved) return;
        var dx = event.clientX - dragStartX;
        var from = Math.round(dragStartLeft / Math.max(1, track.clientWidth));
        var target = slideIndex();
        if (target === from && Math.abs(dx) > 40) target = from + (dx < 0 ? 1 : -1);
        target = Math.max(0, Math.min(slides.length - 1, target));
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = '';
        track.classList.remove('is-dragging');
        track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
      track.addEventListener('click', function (event) {
        if (dragMoved) {
          event.preventDefault();
          event.stopPropagation();
          dragMoved = false;
        }
      }, true);
      track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    }

    var starting = track ? track.querySelector('.starting-slide') : null;
    if (starting) {
      var startIndex = slides.indexOf(starting);
      if (startIndex > 0) requestAnimationFrame(function () { goTo(startIndex, true); });
    }

    /* zoom dialog */
    var lightbox = root.querySelector('[data-inv-lightbox]');
    var lightboxImg = root.querySelector('[data-inv-lightbox-img]');
    var zoomIndex = 0;
    var zoomables = slides.filter(function (s) { return s.querySelector('img[data-photoswipe-src]'); });

    function showZoom(i) {
      if (!lightbox || !zoomables.length) return;
      var n = zoomables.length;
      zoomIndex = ((i % n) + n) % n;
      var img = zoomables[zoomIndex].querySelector('img[data-photoswipe-src]');
      lightboxImg.src = img.getAttribute('data-photoswipe-src');
      lightboxImg.alt = img.alt || '';
      if (!lightbox.open) lightbox.showModal();
    }

    root.addEventListener('click', function (event) {
      var zoomBtn = event.target.closest('[data-inv-zoom]');
      if (zoomBtn && lightbox) {
        hydrateSlides();
        var slide = zoomBtn.closest('.product-main-slide');
        showZoom(Math.max(0, zoomables.indexOf(slide)));
        return;
      }
      if (event.target.closest('[data-inv-lightbox-close]') || event.target === lightbox) {
        lightbox.close();
        return;
      }
      var step = event.target.closest('[data-inv-lightbox-step]');
      if (step) showZoom(zoomIndex + Number(step.getAttribute('data-inv-lightbox-step')));
    });

    /* ---------------- variants ---------------- */
    var variants = data.variants || [];

    function offerFor(v) {
      var price = v.price;
      var compare = v.compare_at_price || 0;
      if (data.upfrontFlat) {
        var diff = Math.max(0, compare - price);
        return { text: 'Save ₹' + Math.round(diff / 100), hidden: diff === 0, icash: null };
      }
      var rupee = price / 100;
      var pct = 0.15;
      var code = 'FLAT20';
      if (rupee >= 545 && rupee <= 848) { pct = 0.2; code = 'FLAT25'; }
      else if (rupee >= 849) { pct = 0.3; code = 'FLAT35'; }
      var base = price * pct;
      var after = price - base;
      var prepaid = after / 100 <= 500 ? 5000 : after * 0.05;
      var finalPrice = price - base - prepaid;
      return {
        text: 'Get it for ₹' + Math.round(finalPrice / 100) + ' with ' + code,
        hidden: false,
        icash: Math.round((finalPrice * 0.07) / 100)
      };
    }

    function setVariant(variant) {
      if (!variant) return;
      var onSale = variant.compare_at_price > variant.price;

      sectionEl.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (input) {
        input.value = variant.id;
      });

      root.querySelectorAll('[data-inv-variant]').forEach(function (card) {
        var active = Number(card.getAttribute('data-inv-variant')) === variant.id;
        card.classList.toggle('active', active);
        card.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      root.querySelectorAll('[data-inv-price-text]').forEach(function (el) { el.textContent = money(variant.price); });
      root.querySelectorAll('[data-inv-compare-text]').forEach(function (el) { el.textContent = money(variant.compare_at_price); });
      root.querySelectorAll('[data-inv-regular]').forEach(function (el) { el.hidden = onSale; });
      root.querySelectorAll('[data-inv-sale]').forEach(function (el) { el.hidden = !onSale; });
      root.querySelectorAll('[data-inv-save]').forEach(function (el) {
        el.hidden = !onSale;
        var t = el.querySelector('[data-inv-save-text]');
        if (t) t.textContent = money(variant.compare_at_price - variant.price, true);
      });
      root.querySelectorAll('[data-inv-sku]').forEach(function (el) { el.textContent = variant.sku || ''; });

      var offer = offerFor(variant);
      root.querySelectorAll('[data-inv-offer]').forEach(function (el) {
        el.hidden = offer.hidden;
        var t = el.querySelector('[data-inv-offer-text]');
        if (t) t.textContent = offer.text;
      });
      root.querySelectorAll('[data-inv-icash]').forEach(function (el) {
        if (offer.icash !== null) el.textContent = offer.icash;
      });

      sectionEl.querySelectorAll('[data-inv-cart-bar]').forEach(function (wrap) {
        wrap.setAttribute('data-variant-id', variant.id);
      });
      sectionEl.querySelectorAll('[data-inv-atc]').forEach(function (btn) {
        btn.setAttribute('data-id', variant.id);
        btn.disabled = !variant.available;
        btn.classList.toggle('is-sold-out', !variant.available);
        var text = btn.querySelector('[data-inv-atc-text]');
        if (text) text.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        var icon = btn.querySelector('[data-inv-atc-icon]');
        if (icon) icon.hidden = !variant.available;
      });

      if (variant.featured_media_id) {
        hydrateSlides();
        var slide = track && track.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (slide) goTo(slides.indexOf(slide));
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-inv-variant]');
      if (!card) return;
      event.preventDefault();
      var id = Number(card.getAttribute('data-inv-variant'));
      setVariant(variants.filter(function (v) { return v.id === id; })[0]);
    });

    /* ---------------- iCash popover ---------------- */
    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-icash-trigger]');
      var infos = root.querySelectorAll('[data-icash-info]');
      if (trigger) {
        var info = trigger.closest('[data-icash-info]');
        var open = !info.classList.contains('is-open');
        infos.forEach(function (el) {
          el.classList.remove('is-open');
          var t = el.querySelector('[data-icash-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (open) {
          info.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!event.target.closest('[data-icash-info]')) {
        infos.forEach(function (el) { el.classList.remove('is-open'); });
      }
    });

    /* ---------------- coupon copy ---------------- */
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-offer-copy]');
      if (!button) return;
      var code = button.getAttribute('data-offer-copy');
      var label = button.querySelector('.pdp-inline-offer__code-label');
      var value = button.querySelector('.pdp-inline-offer__code-value');
      var done = function () {
        label.textContent = 'Code';
        value.textContent = 'Copied!';
        setTimeout(function () {
          label.textContent = 'Use Code';
          value.textContent = code;
        }, 1200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      }
    });

    /* ---------------- sticky bar spacer ---------------- */
    var bar = sectionEl.querySelector('[data-inv-bar]');
    if (bar) {
      var spacerId = 'inv-mp-bar-spacer-' + sectionId;
      var spacer = document.getElementById(spacerId);
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.id = spacerId;
        spacer.setAttribute('aria-hidden', 'true');
        // Horizon scrolls .page-wrapper (not <body>) from 990px up, so the
        // spacer has to live inside it or the fixed bar covers the footer.
        spacer.style.flex = '0 0 auto';
        (document.querySelector('.page-wrapper') || document.body).appendChild(spacer);
      }
      var syncSpacer = function () { spacer.style.height = bar.offsetHeight + 'px'; };
      // ResizeObserver fires once after the first layout (and on every size
      // change), so no synchronous height read is needed when it exists.
      if (window.ResizeObserver) new ResizeObserver(syncSpacer).observe(bar);
      else requestAnimationFrame(syncSpacer);
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.detail && event.detail.sectionId === sectionId && spacer.parentNode) spacer.parentNode.removeChild(spacer);
      });
    }

    /* ---------------- sticky add to cart (Innovist block-buy-buttons) ---------------- */
    var cartBar = sectionEl.querySelector('[data-inv-cart-bar]');
    if (cartBar) initCartBar(cartBar, sectionEl);

    /* ---------------- estimated delivery (Shiprocket) ---------------- */
    var edd = root.querySelector('[data-inv-edd]');
    if (edd) {
      window.shiprocketEddLoader = window.shiprocketEddLoader || (function () {
        var scriptUrl = 'https://fastrr-edd.pickrr.com/index.js';
        var loaderPromise = null;
        function getFn() {
          return typeof window.getShiprocketEDD === 'function' ? window.getShiprocketEDD : null;
        }
        function waitForFn(timeout) {
          return new Promise(function (resolve, reject) {
            var started = Date.now();
            (function check() {
              var fn = getFn();
              if (fn) return resolve(fn);
              if (Date.now() - started >= timeout) return reject(new Error('getShiprocketEDD was not exposed'));
              setTimeout(check, 100);
            })();
          });
        }
        function load() {
          var fn = getFn();
          if (fn) return Promise.resolve(fn);
          if (loaderPromise) return loaderPromise;
          loaderPromise = new Promise(function (resolve, reject) {
            var script = document.querySelector('script[data-shiprocket-edd-script="true"]');
            var afterLoad = function () { waitForFn(10000).then(resolve).catch(reject); };
            if (script) {
              if (script.dataset.loaded === 'true') return afterLoad();
              script.addEventListener('load', afterLoad, { once: true });
              script.addEventListener('error', function () { reject(new Error('Shiprocket EDD script failed to load')); }, { once: true });
              return;
            }
            script = document.createElement('script');
            script.src = scriptUrl;
            script.async = true;
            script.dataset.shiprocketEddScript = 'true';
            script.addEventListener('load', function () { script.dataset.loaded = 'true'; afterLoad(); }, { once: true });
            script.addEventListener('error', function () { reject(new Error('Shiprocket EDD script failed to load')); }, { once: true });
            document.head.appendChild(script);
          }).catch(function (error) {
            loaderPromise = null;
            throw error;
          });
          return loaderPromise;
        }
        return { load: load };
      })();

      var eddData = {};
      try { eddData = JSON.parse(edd.querySelector('[data-inv-edd-json]').textContent); } catch (e) {}
      var input = edd.querySelector('.sr-edd__input');
      var result = edd.querySelector('.sr-edd__result');
      var button = edd.querySelector('.sr-edd__button');
      var buttonLabel = button.querySelector('.sr-edd__button-label');
      var message = edd.querySelector('.sr-edd__message');
      var state = 'entry';
      var timer = null;

      var setLoading = function () {
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (!button.querySelector('.sr-edd__spinner')) {
          var spinner = document.createElement('span');
          spinner.className = 'sr-edd__spinner';
          spinner.setAttribute('role', 'status');
          spinner.setAttribute('aria-label', 'Checking');
          button.appendChild(spinner);
        }
      };
      var setLabel = function (text) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        var spinner = button.querySelector('.sr-edd__spinner');
        if (spinner) spinner.remove();
        buttonLabel.textContent = text;
      };
      var currentVariant = function () {
        var idInput = sectionEl.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = Number((idInput && idInput.value) || eddData.initial_variant_id);
        return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
      };
      var extract = function (payload) {
        if (payload === null || payload === undefined) return null;
        if (typeof payload === 'string' || typeof payload === 'number') return payload;
        if (Array.isArray(payload)) {
          for (var i = 0; i < payload.length; i++) {
            var v = extract(payload[i]);
            if (v !== null && String(v).trim() !== '') return v;
          }
          return null;
        }
        var keys = ['edd', 'EDD', 'edd_date', 'eddDate', 'estimated_delivery_date', 'estimatedDeliveryDate', 'delivery_date', 'deliveryDate', 'promised_date', 'promisedDate', 'edd_message', 'delivery_slot', 'date'];
        for (var k = 0; k < keys.length; k++) {
          if (Object.prototype.hasOwnProperty.call(payload, keys[k]) && payload[keys[k]] !== null && payload[keys[k]] !== undefined && String(payload[keys[k]]).trim() !== '') return extract(payload[keys[k]]);
        }
        var nested = ['edd_details', 'data', 'result', 'response'];
        for (var n = 0; n < nested.length; n++) {
          if (payload[nested[n]] !== null && payload[nested[n]] !== undefined) {
            var nv = extract(payload[nested[n]]);
            if (nv !== null) return nv;
          }
        }
        return null;
      };
      var format = function (value) {
        var raw = String(value).trim();
        if (/^\d{4}-\d{2}-\d{2}/.test(raw) || /^\d{2}[/-]\d{2}[/-]\d{4}/.test(raw) || /[a-zA-Z]{3,}\s+\d{1,2}/.test(raw)) {
          var ts = Date.parse(raw);
          if (!isNaN(ts)) return new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(ts));
        }
        return raw;
      };
      var reset = function (focus) {
        clearTimeout(timer);
        state = 'entry';
        result.hidden = true;
        result.textContent = '';
        result.classList.remove('is-error');
        input.hidden = false;
        input.value = '';
        input.placeholder = 'Enter Pincode';
        setLabel('Check');
        button.disabled = false;
        message.textContent = '';
        message.hidden = true;
        if (focus) requestAnimationFrame(function () { input.focus(); });
      };
      var tempError = function (text) {
        clearTimeout(timer);
        state = 'temporary-message';
        input.hidden = true;
        result.textContent = text;
        result.hidden = false;
        result.classList.add('is-error');
        setLabel('Check');
        button.disabled = true;
        timer = setTimeout(function () { reset(true); }, 2000);
      };
      var showResult = function (text) {
        clearTimeout(timer);
        input.hidden = true;
        result.textContent = text;
        result.hidden = false;
        result.classList.remove('is-error');
        setLabel('Change');
        button.disabled = false;
        state = 'result';
      };
      var check = function () {
        if (state === 'result') return reset(true);
        if (state === 'temporary-message') return;
        var pincode = input.value.replace(/\D/g, '').slice(0, 6);
        input.value = pincode;
        if (!/^[1-9][0-9]{5}$/.test(pincode)) {
          input.placeholder = 'Enter Pincode';
          return tempError('Please enter a valid 6-digit pincode.');
        }
        var v = currentVariant();
        if (!v) return tempError('Please select a product variant.');
        if (!v.available) return tempError('The selected variant is currently unavailable.');
        if (eddData.edd_exclude) return tempError('Delivery estimate is unavailable for this product.');
        button.disabled = true;
        setLoading();
        var productData = {
          product_id: Number(eddData.product_id),
          variant_id: Number(v.id),
          sku: v.sku || '',
          title: v.title && v.title !== 'Default Title' ? eddData.title + ' - ' + v.title : eddData.title,
          quantity: 1,
          price: Number(v.price) / 100,
          variants: variants.map(function (x) { return { variant_id: Number(x.id), available: Boolean(x.available) }; }),
          product_available: Boolean(eddData.product_available),
          variant_available: Boolean(v.available),
          edd_exclude: Boolean(eddData.edd_exclude)
        };
        window.shiprocketEddLoader.load()
          .then(function (getShiprocketEDD) { return getShiprocketEDD({ pincode: pincode, product_data: productData }); })
          .then(function (response) {
            var value = extract(response);
            if (value === null || String(value).trim() === '') throw new Error('No delivery estimate returned');
            showResult(format(value) + ', ' + pincode);
          })
          .catch(function (error) {
            console.error('Shiprocket EDD error:', error);
            tempError('Delivery estimate unavailable right now.');
          });
      };

      input.addEventListener('focus', function () { if (!input.value) input.placeholder = 'Enter Pincode'; });
      input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          check();
        }
      });
      button.addEventListener('click', check);
      document.addEventListener('variant:change', function () { if (state === 'result') reset(false); });
    }
  }

  /* Port of Innovist's block-buy-buttons script. The button calls /cart/add.js
     directly (no form submit, so the Shiprocket side cart doesn't take over),
     shows an inline loader, then swaps to − qty + / View Cart. The header count
     is pushed to Horizon's <cart-icon>, and Shiprocket is told to refresh. */
  function initCartBar(wrap, sectionEl) {
    var addBtn = wrap.querySelector('.add-to-cart');
    var qtyUi = wrap.querySelector('.qty-ui');
    var qtyValueEl = wrap.querySelector('.qty');
    var qtySel = wrap.querySelector('.quantity-selector');
    var qtyLoader = wrap.querySelector('.qty-inline-loader');
    var errorEl = sectionEl.querySelector('[data-inv-atc-error]');
    var notifEl = sectionEl.querySelector('[data-inv-cart-notif]');
    var isRequesting = false;
    var lineItemKey = null;
    var serverQty = 0;
    var notifTimer = null;
    var errorTimer = null;
    var OWN = '__invCartBar';

    function variantId() { return wrap.getAttribute('data-variant-id'); }

    function showNotification() {
      if (!notifEl) return;
      notifEl.classList.add('active');
      clearTimeout(notifTimer);
      notifTimer = setTimeout(function () { notifEl.classList.remove('active'); }, 3000);
    }
    function hideNotification() {
      if (!notifEl) return;
      notifEl.classList.remove('active');
      clearTimeout(notifTimer);
    }
    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.remove('hidden');
      clearTimeout(errorTimer);
      errorTimer = setTimeout(function () { errorEl.classList.add('hidden'); }, 4000);
    }

    /* header count: Horizon <cart-icon> */
    function cartIcons() { return document.querySelectorAll('cart-icon'); }
    function setHeaderCount(count, animate) {
      cartIcons().forEach(function (icon) {
        if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count, animate !== false);
      });
    }
    function bumpHeaderCount(delta) {
      cartIcons().forEach(function (icon) {
        if (typeof icon.renderCartBubble !== 'function') return;
        var current = Number(icon.currentCartCount) || 0;
        icon.renderCartBubble(Math.max(0, current + delta), delta > 0);
      });
    }

    function refreshSidecart() {
      window.postMessage({ name: 'SRSC_UPDATE_CART', body: {} }, '*');
    }

    function cartRequest(url, body) {
      var opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      };
      opts[OWN] = true;
      return fetch(url, opts).then(function (res) {
        if (res.ok) return res.json();
        return res.json().catch(function () { return {}; }).then(function (json) {
          throw new Error(json.description || json.message || 'Could not update cart. Please try again.');
        });
      });
    }
    function getCart() {
      var opts = { cache: 'no-store', headers: { Accept: 'application/json' } };
      opts[OWN] = true;
      return fetch('/cart.js?ts=' + Date.now(), opts).then(function (res) { return res.json(); });
    }

    function linesForVariant(cart) {
      var id = String(variantId());
      return (cart.items || []).filter(function (item) { return String(item.variant_id) === id; });
    }

    /* renderers */
    function renderQtySelector(qty) {
      if (qtyValueEl) qtyValueEl.textContent = qty;
      if (addBtn) addBtn.style.display = 'none';
      if (qtyUi) qtyUi.style.display = 'flex';
      if (qtyLoader) qtyLoader.style.display = 'none';
    }
    function showAddToCartButton() {
      if (qtyUi) qtyUi.style.display = 'none';
      if (addBtn) addBtn.style.display = '';
    }
    function showLoader() {
      if (qtyUi && qtyUi.style.display !== 'none' && qtySel && qtyLoader) {
        var rect = qtySel.getBoundingClientRect();
        qtyLoader.style.width = rect.width + 'px';
        qtyLoader.style.height = rect.height + 'px';
        qtySel.style.pointerEvents = 'none';
        qtySel.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
        qtyLoader.style.display = 'flex';
        return;
      }
      if (addBtn) {
        addBtn.classList.add('loading');
        addBtn.disabled = true;
      }
    }
    function hideLoader() {
      if (qtyLoader) qtyLoader.style.display = 'none';
      if (qtySel) {
        qtySel.style.pointerEvents = '';
        qtySel.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
      }
      if (addBtn) {
        addBtn.classList.remove('loading');
        addBtn.disabled = addBtn.classList.contains('is-sold-out');
      }
    }

    /* full sync from the real cart (load, errors, external changes) */
    function syncFromCart(animateHeader) {
      return getCart().then(function (cart) {
        var lines = linesForVariant(cart);
        // B1G1 can split a variant over lines: use the biggest one for +/−.
        var primary = lines.slice().sort(function (a, b) { return b.quantity - a.quantity; })[0];
        lineItemKey = primary ? primary.key : null;
        serverQty = lines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        if (!isRequesting) {
          if (serverQty > 0) renderQtySelector(serverQty);
          else showAddToCartButton();
        }
        setHeaderCount(cart.item_count, animateHeader === true);
        return cart;
      });
    }

    function pushAddToCartEvent(item) {
      if (!item) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'Custom_addtocart',
        ecommerce: {
          page_location: window.location.href,
          page_title: document.title,
          ecomm_pagetype: 'Product Page',
          value: (item.final_price || item.price || 0) / 100,
          currency: 'INR',
          items: [{
            item_id: 'shopify_IN_' + item.product_id + '_' + item.variant_id,
            item_name: item.product_title,
            item_brand: item.vendor,
            item_category: item.product_type || 'null',
            price: (item.final_price || item.price || 0) / 100,
            quantity: 1,
            item_variant: item.variant_title || 'null'
          }]
        }
      });
    }

    function afterMutation() {
      refreshSidecart();
      syncFromCart(false).catch(function () {});
    }

    function addOne() {
      if (isRequesting) return;
      isRequesting = true;
      showLoader();
      cartRequest('/cart/add.js', { id: Number(variantId()), quantity: 1 })
        .then(function (item) {
          if (item && item.key) lineItemKey = item.key;
          serverQty += 1;
          isRequesting = false;
          hideLoader();
          renderQtySelector(serverQty);
          showNotification();
          bumpHeaderCount(1);
          pushAddToCartEvent(item);
          afterMutation();
        })
        .catch(function (error) {
          isRequesting = false;
          hideLoader();
          showError(error.message);
          syncFromCart(false).catch(function () {});
        });
    }

    function removeOne() {
      if (isRequesting || !lineItemKey) return;
      isRequesting = true;
      showLoader();
      var newQty = Math.max(0, serverQty - 1);
      cartRequest('/cart/change.js', { id: lineItemKey, quantity: newQty })
        .then(function (cart) {
          isRequesting = false;
          hideLoader();
          serverQty = newQty;
          if (newQty > 0) renderQtySelector(newQty);
          else {
            lineItemKey = null;
            showAddToCartButton();
          }
          hideNotification();
          setHeaderCount(cart.item_count, false);
          afterMutation();
        })
        .catch(function (error) {
          isRequesting = false;
          hideLoader();
          showError(error.message);
          syncFromCart(false).catch(function () {});
        });
    }

    function openCart() {
      if (typeof window.slideShiprocketSmartCartInFrame === 'function') {
        window.slideShiprocketSmartCartInFrame();
      } else {
        window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      }
    }

    wrap.addEventListener('click', function (event) {
      if (event.target.closest('.add-to-cart')) {
        event.preventDefault();
        if (!addBtn.classList.contains('is-sold-out')) addOne();
      } else if (event.target.closest('.increase-qty')) {
        event.preventDefault();
        addOne();
      } else if (event.target.closest('.decrease-qty')) {
        event.preventDefault();
        removeOne();
      } else if (event.target.closest('.view-cart-btn')) {
        event.preventDefault();
        openCart();
      }
    });

    /* External cart changes (Shiprocket side cart, other ATC buttons on the page). */
    var syncTimer = null;
    function scheduleSync(delay) {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () { syncFromCart(false).catch(function () {}); }, delay);
    }
    if (!window.__invCartBarFetchHooked) {
      window.__invCartBarFetchHooked = true;
      var originalFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var own = init && init[OWN] === true;
        return originalFetch.apply(this, arguments).then(function (response) {
          if (!own && response.ok && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
            document.dispatchEvent(new CustomEvent('inv:cart-mutated'));
          }
          return response;
        });
      };
    }
    document.addEventListener('inv:cart-mutated', function () { scheduleSync(150); });
    window.addEventListener('message', function (event) {
      var name = event.data && event.data.name;
      if (['quantity_change', 'item_added', 'item_removed', 'cart_update'].indexOf(name) !== -1) scheduleSync(0);
    });
    document.addEventListener('variant:change', function () { scheduleSync(0); });
    window.addEventListener('pageshow', function (event) { if (event.persisted) scheduleSync(0); });

    syncFromCart(false).catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('.inv-mp[data-section-id]').forEach(function (root) {
      if (root.dataset.invMpReady === 'true') return;
      root.dataset.invMpReady = 'true';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
